import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa6";
import { SlSocialLinkedin } from "react-icons/sl";
import Text from "../Common/Text";

interface Props {
  websiteName: string;
  facebook: string;
  instagram: string;
  tikTok: string;
  linkedin: string;
  copyright: string;
  links: FooterLink[];
  onChange: any;
}

export interface FooterLink {
  id: number;
  path: string;
  name: string;
  type: Type;
}

export enum Type {
  Internal = "internal",
}

const Footer = ({
  websiteName,
  facebook,
  instagram,
  tikTok,
  linkedin,
  copyright,
  links,
  onChange,
}: Props) => {
  return (
    <footer className="bg-[--primary800] ">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="lg:flex lg:justify-between">
          <div className="mb-6 md:mb-0">
            <a
              href="https://web.dogtorsoftware.com"
              className="flex items-center"
            >
              <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">
                {websiteName}
              </span>
            </a>
            {/* <p className="font-normal text-sm max-w-72 text-white mt-8">
              {copyright}
            </p> */}

            <div style={{ minWidth: "280px" }}>
              <Text
                editor={!!onChange}
                id="Callout"
                onChange={(val: any) => onChange?.(val, "title")}
              >
                {copyright}
              </Text>
            </div>
          </div>

          <div>
            <div
              className="grid grid-cols-2 gap-x-8 sm:gap-x-6 sm:grid-cols-3 mt-5 lg:mt-0"
              style={{ marginLeft: "10px" }}
            >
              {links?.map((item) => (
                <div key={item?.id}>
                  <a
                    href={item?.path}
                    className="text-sm font-medium uppercase text-white hover:text-[--primary300] hover:underline"
                  >
                    {item?.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>

        <hr className="my-6 border-white sm:mx-auto lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm sm:text-center text-white">
            © {new Date().getFullYear()}{" "}
            <a href="https://magoagencia.co/" className="hover:underline">
              Mago Agencia
            </a>
            . Todos los derechos reservados.
          </span>
          <div className="flex mt-4 sm:justify-center sm:mt-0">
            {facebook && (
              <a href={facebook} className="text-white ms-5">
                <FaFacebookF />
              </a>
            )}

            {instagram && (
              <a href={instagram} className="text-white ms-5">
                <FaInstagram />
              </a>
            )}

            {tikTok && (
              <a href={tikTok} className="text-white ms-5">
                <FaTiktok />
              </a>
            )}
            {linkedin && (
              <a href={linkedin} className="text-white ms-5">
                <SlSocialLinkedin />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
